import React from 'react';
import './slider.scss';
import Carousel from 'react-bootstrap/Carousel';
import ResponsiveImage from 'shared/responsive-image/responsive-image';

export function Slider(props) {
  return (
    <Carousel controls={false}>
      {props.ads.map(ad => (
        <Carousel.Item key={ad.name}>
          <ResponsiveImage
            src={ad.image}
            className="d-block w-100 mx-auto"
            alt={ad.name}
            width={6000}
            height={4000}
          />
          <Carousel.Caption>
            <h3>{ad.name}</h3>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default Slider;
